<template>
  <div class="slide2">
    <div class="slide2-inner">
      <div class="slide2-left">
        <div class="S2L-phone">
          <img src="@/assets/green-phone.png" />
        </div>
        <div class="S2L-video">
          <img src="@/assets/temp_main.png" />
          <!-- <video muted autoplay loop playsinline>
                        <source src="https://qyuyzyggndee2252511.gcdn.ntruss.com/images/video-1.mp4" type="video/mp4">
          </video>-->
        </div>
      </div>
      <div class="slide2-right" :style="cssProps">
        <div class="S2R-big">ON STYLE LIVE는 라이브 커머스 서비스입니다</div>
        <div class="S2R-small">- 실시간 라이브 방송 , 상품 무료 홍보 등 서비스를 지원하고 있습니다</div>
        <div class="S2R-button">
          준비중입니다.
          <!-- <router-link to="/joinus" class="S2R-button-name">입점 신청 바로가기</router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Slide2",
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/S2-right-bg.png")})`
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.slide2 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  .slide2-inner {
    height: 100%;
    margin-left: 80px;
    margin-right: 80px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    position: relative;

    .slide2-left {
      width: 50%;
      background-color: #bfdfd9;
      padding-top: 50px;
      padding-bottom: 50px;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      position: relative;

      .S2L-phone {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 290px;
        height: 602px;
      }

      .S2L-video {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 272px;
        height: 568px;
        border-radius: 24px;
        overflow: hidden;
        object-fit: contain;

        video {
          width: 272px;
          height: 568px;
        }
        img {
          width: 272px;
          //   height: 568px;
        }
      }
    }

    .slide2-right {
      width: 50%;
      height: 100%;
      padding-left: 30px;
      box-sizing: border-box;
      display: flex;
      background-size: contain;
      background-repeat: no-repeat;
      flex-direction: column;
      justify-content: center;
      position: relative;

      .S2R-big {
        font-size: 24px;
        font-weight: 900;
        color: #525252;
        margin-bottom: 10px;
      }

      .S2R-small {
        font-size: 18px;
        margin-bottom: 50px;
        color: #525252;
      }

      .S2R-button {
        width: 180px;
        height: 50px;
        border-radius: 25px;
        text-align: center;
        line-height: 50px;
        background-color: #aca599;
        cursor: pointer;

        .S2R-button-name {
          color: #ffffff;
          text-decoration: none;
        }

        &:hover {
          background-color: #948e82;
        }
      }
    }
  }
}
</style>